import script from "./LayoutRenderer.vue?vue&type=script&lang=ts"
export * from "./LayoutRenderer.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__